// src/components/CreateBookSection.js

import React from 'react';

const CreateBookSection = ({ t, addToRefs }) => {
  return (
    <section className="cb-section py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Sol Taraf - Resim */}
          <div className="col-lg-6 mb-4 mb-lg-0 cb-slide-in cb-slide-left" ref={addToRefs}>
            <img
              src="/images/bg/003.jpg"
              alt={t('homePage.createBook.imageAlt')}
              className="img-fluid rounded shadow"
              loading="lazy"
            />
          </div>
          
          {/* Sağ Taraf - İçerik */}
          <div className="col-lg-6 cb-slide-in cb-slide-right" ref={addToRefs}>
            <h2 className="cb-title mb-3">{t('homePage.createBook.title')}</h2>
            <h6 className="cb-subtitle mb-4">{t('homePage.createBook.subtitle')}</h6>
            <div className="cb-content">
              {/* İçerik paragraflarını map ile dinamik olarak oluşturma */}
              {t('homePage.createBook.content', { returnObjects: true }).map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
            <a href="/contact" className="btn-custom">
              {t('homePage.createBook.button')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreateBookSection;